/* eslint-disable id-length */
export const ALL_USERS = 'https://jsonplaceholder.typicode.com/users';
export const AUDIT_LOGIN = '/v1/users/loginaudit';
export const VERIFY_ACCESS_TOKEN = '/v1/users/verify-access-token';
export const LOGOUT = '/v1/logout';
export const TBH_EMPLOYEE_MANAGEMENT = '/v1/tbh-employee-management';
export const TBH_EMPLOYEE_MANAGEMENT_CREATE = '/v1/tbh-employee-management/create';
export const TBH_EMPLOYEE_MANAGEMENT_FILTERS = '/v1/tbh-employee-management/filters';
export const GENERATE_BEARER_TOKEN = '/v1/generate-token';
export const GET_ALL_USER_ROLES = '/v1/roles';
export const GET_USER_ROLES = '/v1/users';

export const ROLES_LIST = '/v1/roles';
export const ENABLE_OR_DISABLE_ROLE = '/v1/roles/enable-or-disable';
export const ADD_EDIT_ROLES = '/v1/roles';

export const CLIENT_DETAILS_LIST = '/v1/client-details';
export const ENABLE_OR_DISABLE_CLIENT = '/v1/client-details/enable-or-disable';
export const ADD_EDIT_CLIENT_DETAILS = '/v1/client-details/toggle-status';
export const CLIENT_DETAILS_REPORT_PDF = '/v1/client-details/reports?format=pdf';
export const CLIENT_DETAILS_REPORT_EXCEL = '/v1/client-details/reports?format=excel';

export const ALLOCATION_MAIL_STAKEHOLDERS_LIST = '/v1/allocation-mail-stakeholders';
export const ALLOCATION_MAIL_STAKEHOLDERS_TOGGLE = '/v1/allocation-mail-stakeholders/toggle-status';

// Finance (Project MS) tables
export const FINANCE_CLIENT_DETAILS_LIST = '/v1/finance-client-details';
export const ZOHO_CLIENT_DETAILS_LIST = '/v1/zoho-client-details';
export const FINANCE_EMPLOYEE_COST = '/v1/finance/employee-cost';
export const PROJECT_EMPLOYEE_COST = '/v1/finance/project-employee-cost';
export const PROJECT_WISE_EXPENSE_REPORT = '/v1/project-wise-expense-report';
export const MILESTONE_REPORT = '/v1/milestone-report';
export const PROJECT_EMPLOYEE_COST_CONFIG = '/v1/finance/project-employee-cost/config';
export const PROJECT_EMPLOYEE_COST_FILTERS = '/v1/finance/project-employee-cost/filters';
export const PROJECT_EMPLOYEE_COST_EXPORT = '/v1/finance/project-employee-cost/export';
export const ACCRUED_REVENUE_REPORT = '/v1/finance/accrued-revenue';
export const ACCRUED_REVENUE_REPORT_FILTERS = '/v1/finance/accrued-revenue/filters';
export const ACCRUED_REVENUE_REPORT_EXPORT = '/v1/finance/accrued-revenue/export';

export const ZOHO_CUSTOMER_DETAILS_LIST = '/v1/zoho-customer-details';
export const ADD_EDIT_ZOHO_CUSTOMER_DETAILS = '/v1/zoho-customer-details';
export const ENABLE_OR_DISABLE_ZOHO_CUSTOMER = '/v1/zoho-customer-details/toggle-status';
export const ZOHO_CUSTOMER_DETAILS_REPORT_PDF = '/v1/zoho-customer-details/reports?format=pdf';
export const ZOHO_CUSTOMER_DETAILS_REPORT_EXCEL = '/v1/zoho-customer-details/reports?format=excel';

export const ZOHO_INVOICE_DETAILS = '/v1/zoho-invoice-details';
export const REGION_LIST = '/v1/region-list';
export const INVOICE_TYPE = '/v1/invoice-type';
export const DELIVERY_METHODOLOGY = '/v1/delivery-methodology';
export const COUNTRY_LIST = '/v1/country-list';
export const RESOURCE_MANAGEMENT = '/api/v1/resource-management';
export const RESOURCE_MANAGEMENT_FILTER = '/api/v1/resource-management/filter/resource-management-filter';
export const RESOURCE_MANAGEMENT_EXPORT = '/api/v1/resource-management/export';

export const EMPLOYEE_MASTER = '/v1/employee-master-management';

export const REPORT_PDF = '/v1/reports?format=pdf';
export const REPORT_EXCEL = '/v1/reports?format=excel';
export const MASTER_VERTICAL = '/v1/vertical/';
export const CONFERENCE_ROOM = '/v1/conference-rooms';
export const GET_SKILLS = '/v1/skills';
export const MASTER_DEPARTMENT = '/v1/department';
export const MASTER_DESIGNATION = '/v1/designation';
export const CLOUD_PROVIDER = '/v1/cloud-provider';
export const ENABLE_OR_DISABLE_SKILLS = '/v1/skills/enable-or-disable';
export const SKILL_DUMP_UPLOAD = '/v1/dump-skills/upload';
export const SKILL_DUMP_SAMPLE_FILE = '/v1/dump-skills/get-sample-file';
export const CERTIFICATIONS_LIST = '/v1/certification';
export const ENABLE_DISABLE_CERTIFICATION = '/v1/certification/enable-or-disable';
export const ADD_EDIT_CERTIFICATION = '/v1/certification';
export const CERTIFICATION_MAP_LIST = '/v1/certification-map';
export const ADD_EDIT_TARGETS = '/v1/targets/';
export const SKILL_MAP_REPORT_PDF = '/v1/skill-map/reports?format=pdf';
export const SKILL_MAP_REPORT_EXCEL = '/v1/skill-map/reports?format=excel';
export const DELETE_CERTIFICATION_MAP = '/v1/certification-map/{mapId}';
export const CERTIFICATION_MAP_REPORT_PDF = '/v1/certification-map/reports?format=pdf';
export const CERTIFICATION_MAP_REPORT_EXCEL = '/v1/certification-map/reports?format=excel';
export const GET_TARGETS = '/v1/targets/{year}';
export const CERTIFICATION_VERTICAL_COUNT = '/v1/certification-map/count';
export const CHANGE_REQUEST = '/v1/project-change-requests';
export const NOTIFICATON = '/v1/notificaton';
export const TIMELINE_CHANGE_REQUEST = '/v1/timeline-change-request';
export const TIMELINE_CHANGE_REQUEST_STATUS = '/v1/timeline-change-request/status';
export const DELETE_TARGET = '/v1/targets/delete';
export const ADD_EDIT_CERTIFICATION_MAP = '/v1/certification-map';
export const FETCH_USER_INFO = '/v1/users';
export const FETCH_USER_PROFILE_PICTURE = '/v1/users/profile-picture';

export const RECOGNITIONS_LIST = '/v1/recognitions';
export const SKILL_MAP = '/v1/skill-map';
export const SKILL_MAP_FILTER = '/v1/skill-map-filter';
export const ROLE_MAP_LIST = '/v1/role-map';
export const DELETE_SKILL_MAP = '/v1/skill-map/{mapId}';
export const SKILL_VERTICAL_DEPARTMENT_MAP = '/v1/skill-vertical-department-map';
// eslint-disable-next-line id-length
export const CERTIFICATION_OVERVIEW_DOWNLOAD_URL = '/v1/certification-overview/reports/';
export const STAFF_AUGMENTATION_DOWNLOAD_URL = '/v1/staff-augmentation/reports';
export const AWARDS_LIST = '/v1/awards';
export const DRI_LIST = '/v1/dri';
export const KPI = '/v1/kpi';
export const KPI_CATEGORY_MASTER = '/v1/kpi-category-master';
export const KPI_TARGET_FORMAT = '/v1/kpi-target-format';
export const KPI_MASTER = '/v1/kpi-master';
export const PERFORMANCE_PERIOD_MASTER = '/v1/performance-period-master';
export const PROJECT_DETAILS = '/projects';
export const DEAL_ROLE_MASTER = '/v1/roles?isDtRoles=true';
export const ENABLE_OR_DISABLE_DEAL_ROLE = '/v1/roles/enable-or-disable';
export const DEAL_STATUS_LIST = '/v1/deal-master/status';
export const LOST_DROPPED_STATUS = '/v1/lost-dropped-status';
export const PERFORMANCE_PERIOD_DETAILS = '/v1/performance-period-master';
export const PERFORMANCE_KPI_DETAILS = '/v1/user-kpi-scores';
export const KPI_PERFORMANCE_CYCLE = '/v1/fetch-kpi-performance-cycle';
export const DEAL_TRANSITION_FORM = '/v1/deal-transition-form';
export const DEAL_DETAIL_VIEW = '/v1/deal-deatiled-view';
export const DEAL_PARAMETERS_MASTER = '/v1/dealParameters';
export const DEAL_PARAMETERS_SLA = '/v1/dealParameters/sla';
export const DEAL_PARAMETERS_WORKFLOW = '/v1/dealParameters/workflow';
export const DASHBOARD = '/v1/dashboard';
export const CERTIFICATION_CATEGORY_MASTER = '/v1/certification-category-master';
export const COLUMN_CUSTOMIZATION = '/v1/customcolumn/column';
export const GET_COLUMN_DATA = '/v1/customcolumn/getcolumn';
export const DEAL_TRANSITION_DETAILS = '/v1/deal-transition-details';
export const DEAL_SAVE_FOR_LATER = '/v1/save-later-deal-transition-deatils';
export const GET_TABULAR_VIEW = '/v1/tabular-view';
export const HIRING_DETAILS = '/v1/hiring-details';
export const BE_EFFORT = '/v1/be-effort';
export const BE_EFFORT_WITH_BULK_EDIT = '/v1/be-effort/bulk-edit-deal-be-effort';
export const TRIGGER_EFFORT_UPLOAD = '/v1/jira-manual-effort-upload';
export const TRIGGER_LEAVE_UPLOAD = '/v1/zoho-manual-leave-upload';
export const EFFORT_HISTORY_LIST = '/v1/scheduler-history/?scheduler-category=jira-work-log';
export const LEAVE_HISTORY_LIST = '/v1/scheduler-history/?scheduler-category=leave-details';
export const UPLOAD_CONFIG_DATES = '/v1/data-upload-configuration';
export const BASE_EFFORT = '/v1/base-effort';
export const TECHNICAL_COMPLEXITY_EFFORT = '/v1/tech-buffer';
export const EXTERNAL_INTEGRATION_EFFORT = '/v1/external-integration-buffer';
export const REQUIREMENT_CLARITY_EFFORT = '/v1/clarity-buffer';
export const COMMERCIAL_WORKFLOW = '/v1/commercial-workflows';
export const EFFORT_WORKFLOW = '/v1/effort-workflows';
export const DASHBOARD_COLLECTIONS = '/v1/collection-dashboard';
export const MIS_RESELLER_REPORT_TABLE = '/v1/reseller-invoice';
export const MIS_RESELLER_REPORT_TABLE_EXPORT = '/v1/reseller-invoice/export';
export const CLOUD_COST = '/v1/cloud-cost';
export const GET_CLOUD_COST = '/v1/get-cloud-cost';
export const GET_CLOUD_COST_DETAILS = '/v1/get-cloud-cost-details';
export const UPDATE_CLOUD_COST = '/v1/update-cloud-cost';
export const STAFFING_STATUS = '/v1/staffing-status';
export const STAFFING_STATUS_MASTER = '/v1/staffing-status';
export const STAFFING_LOST_DROPPED_STATUS = '/v1/lost-dropped-status';
export const STAFFING_STATUS_MASTER_SWITCH = '/v1/staffing-status/{staffId}';
export const DASHBOARD_COLLECTIONS_DSO = '/v1/collection-dashboard/dso';
export const BASE_EFFORTS = '/v1/base-effort?type=base&is_active=true';
export const BASE_EFFORTS_SAVE = '/v1/base-effort';
export const BASE_EFFORTS_EDIT = '/v1/base-effort';
export const BASE_EFFORTS_DELETE = '/v1/base-effort?id=1';
export const TASK_MASTER = '/v1/task-master';
export const PROJECT_MANAGEMENT_MASTERS = '/v1/project-management-masters';
export const EMPLOYEE_MIS = '/v1/employee-MIS';
export const AI_TOOL_MIS = '/v1/ai-tool-mis';
export const CODE_COVERAGE = '/v1/code-coverage-masters';
export const TEST_MASTER = '/v1/test_master';
export const RESELLER_INVOICE_PROJECTION_IMPORT = '/v1/reseller-invoice/import';

export const GET_STAFFING_COST = '/v1/manPower-cost';
export const GET_STAFFING_COST_DETAILS = '/v1/get-manPower-cost';
export const CREATE_MAN_POWER_COST = '/v1/create-manPower-cost';
export const UPDATE_MAN_POWER_COST = '/v1/update-manPower-cost';
export const MAN_POWER_COST_CALCULATION = '/v1/manPower-cost-calculation';
export const TECH_BUFFER = '/v1/tech-buffer';
export const EXTERNAL_INTEGRATION_BUFFER = '/v1/external-integration-buffer';
export const CLARITY_BUFFER = '/v1/clarity-buffer';
export const MANUAL_ASSIGNMENT = '/v1/manual-assignment';
export const OVERALL_BUFFER = '/v1/over-all-buffer';
export const SOFTWARE_COST = '/v1/software-cost-be';
export const HARDWARE_COST = '/v1/hardware-costs';
export const TRAVEL_COST_CITIES = '/v1/cities';
export const TRAVEL_COST = '/v1/travel-costs';
export const CALCULATE_BASE_EFFORT = '/v1/be-effort/calculate';
export const STAFF_AUGEMENTATION = '/v1/staffing-augmentation';
export const RESOURCE_ALLOCATION_RESOURCE = '/v1/resource-allocation-resource';
export const RESOURCE_ALLOCATION_EXPORT = '/v1/resource-allocation-resource/download';
export const RESOURCE_ALLOCATION_DEPARTMENTS = '/v1/resource-allocation-resource/departments';
export const TBH_RESOURCE_ALLOCATION = '/v1/tbh-resource-allocation';
export const FILE_UPLOAD_ENDPOINT = '/v1/file-upload';
export const FILE_UPLOAD_SUMMARY_ENDPOINT = '/v1/file-upload/summary';
export const FILE_UPLOAD_SUBMIT_ENDPOINT = '/v1/file-upload/submit';
export const FILE_UPLOAD_UPLOAD_DATE_ENDPOINT = '/v1/file-upload/upload-date';
export const FILE_UPLOAD_SAMPLE_FILE_ENDPOINT = '/v1/file-upload/get-sample-file';
export const EFFORT_HISTORY_LIST_File_UPLOAD = '/v1/scheduler-history/?scheduler-category=client-effort-log';
export const STAFF_REQUIREMENT = '/v1/resource-requirement';
export const PROJECT_OVERVIEW = '/v1/project-overview';
export const MIS_PMO_HEALTH_CHECK = '/v1/pmo-health-check';
export const REQUEST_RESOURCE = '/v1/resource-requirement';
export const RESOURCE_VIEW_SUGGESSTION = '/v1/resources/match-by-skills';
export const RESOURCE__REQUIREMENT_REPORTS = '/v1/resource-requirement/reports';
export const OPPORTUNITIES_OVERVIEW_REPORTS = '/v1/staffing-opportunities-overview-report';
export const OPPORTUNITIES_REPORT_DOWNLOAD = '/v1/staffing-opportunity-report';

export const TECH_SESSIONS = '/v1/tech-sessions';
export const TECH_SESSION_REQUEST = '/v1/tech-sessions-request';


export const OTHER_EFFORTS = '/v1/deal_other_efforts';
export const OTHER_EFFORTS_SAVE = '/v1/deal_other_efforts';
export const OTHER_EFFORTS_EDIT = '/v1/deal_other_efforts';
export const OTHER_EFFORTS_DELETE = '/v1/deal_other_efforts';

export const STAFFING_COST = '/v1/staffingCost/deal';
export const STAFFING_COST_UPDATE = '/v1/staffingCost/deal';
export const UPLOAD_FILES = '/v1/upload/files';
export const REMOVE_FILES = '/v1/delete/files';


export const FE_EFFORT = '/v1/fe-effort';
export const FE_EFFORT_WITH_BULK_EDIT = '/v1/fe-effort/bulk-edit-deal-fe-effort';
export const CALCULATE_FE_BASE_EFFORT = '/v1/Fe-effort/calculate';
export const EFFORT_SUMMARY = '/v1/effortSummaryScreenBe';
export const EFFORT_SUMMARY_SUBMIT = '/v1/effort/deal';
export const GET_SKILLSET = '/v1/dealSkillsetScope';

export const SITE_CONFIGURATION = '/v1/site-configuration';

export const TECH_COST = '/v1/techCost';
export const GET_EFFORT_APPROVAL = '/v1/effort-approval-dashboard';
export const GET_DEAL_EFFORT_REVIEWERS = '/v1/deal-effort-approvals';

export const GET_TRAINING_DETAILS = '/v1/training-details';
export const GET_CLOSURE_REPORT = '/v1/staffing-closure-overview';
export const CLOSURE_OVERVIEW_REPORT = '/v1/closure-overview-report/download';
export const GET_PENDING_ONBOARDING_REPORT = '/v1/resources-pending-onborading';
export const PENDING_ONBOARDING_DOWNLOAD = '/v1/resources-pending-onborading/download';

export const GET_STAFFING_PENDING_POSITIONS = '/v1/staffing-pending-position-overview';
export const STAFFING_PENDING_POSITIONS_REPORT = '/v1/staffing-pending-positions-reports/download';
export const GET_LOST_DROPPED_OVERVIEW = '/v1/staffing-lost-dropped-overview';
export const GET_LOST_DROPPED_REPORT = '/v1/staffing-lost-dropped-report';
export const GET_SALES_MEMBER_OVERVIEW = '/v1/staffing-sales-member-overview';
export const GET_SALES_MEMBER_REPORT = '/v1/sales-member-overview-report';
export const GET_DELIVERY_MANAGER_OVERVIEW = '/v1/staffing-delivery-manger-overview';
export const GET_DELIVERY_MANAGER_REPORT = '/v1/delivery-manager-overview-report';
export const GET_ASSESSMENT_DETAILS = '/v1/assessment-details';
export const TRIGGER_LEAVE_SYNC = '/v1/sync-leave-data';
export const GET_EMAIL_TEMPLATE = '/v1/get-email-content';
export const SEND_EMAIL_NOTIFICATION = '/v1/send-email-notification';
export const GET_CONFERENCE_ROOM_LIST = '/v1/conference-rooms';
export const DECLARE_SOURCE_REMARK = '/v1/kpi-details';
export const MIS_DEL_DETAILS = '/v1/delivery-utilization';
export const MIS_ARCHITECT_HEALTH_CHECK = '/v1/architect-health-check';
export const HOME_DASHBOARD = '/v1/home-dashboard';
export const HOME_DASHBOARD_FILTERS = '/v1/home-dashboard/filters';
export const HOME_DASHBOARD_EXPORT = '/v1/home-dashboard/export';
export const NOTIFICATIONS = '/v1/notifications';
export const STATUS_CHANGE_REQUESTS = '/v1/project-status/status-history';
export const STATUS_CHANGE_FILTERS = '/v1/projectstatus/filters';
export const GENERATE_RESUME = '/v1/staffing-augmentation/generate-resume';
export const VIEW_RESUME = '/v1/staffing-augmentation/view-resume';
export const STAFFING_GEOGRAPHY = '/v1/staffing-geography';
export const UPLOAD_RESUME = '/v1/staffing-augmentation/upload-resume';
export const UPDATE_RESUME = '/v1/staffing-augmentation/update-resume';
export const CONVERT_RESUME = '/v1/staffing-augmentation/convert-resume';

export const VIEW_FILE = '/v1/staffing-augmentation/view-file';
export const OVERALL_REPORT = '/v1/staffing-overall-report';
export const PERMISSION_REPORT = '/v1/permission-report';
export const USER_DATA_REPORT = '/v1/user-data-report';

export const ADD_PROJECTS = '/v1/master-project';
export const CANCEL_TECH_SESSION = '/v1/tech-sessions/cancel';
export const REGION_COUNTRY = '/v1/region';
export const SPONSOR = '/v1/sponsor';
export const VERTICAL = '/v1/vertical';
export const COST_SPLIT = '/v1/cost-split';
export const REVENUE_SPLIT = '/v1/revenue-split';
export const FP_BILLING_TYPE = '/v1/fp-billing-type';
export const TM_BILLING_TYPE = '/v1/tm-billing-type';
export const BILLING_TYPE = '/v1/billing-type';
export const CLIENT_DETAILS = '/v1/client-details';
export const BILLING_ENTITY = '/v1/billing-entity';
export const SENIOR_MANAGER = '/v1/senior-manager';
export const MASTER_PROJECT_NAME = '/v1/master-project-name';
export const SALES_VERTICAL_MASTER = '/v1/sales-vertical';
export const PROJECT_OFFERINGS_MASTER = '/v1/project-offerings';
export const OPPORTUNITIES_MASTER = '/v1/opportunities';
export const TECHNOLOGY_MASTER = '/v1/technology';
export const DELIVERY_METHODOLOGY_MASTER = '/v1/delivery-methodology';
export const REVENUE_SPLIT_MASTER = '/v1/revenue-split';
export const PROJECT_CUSTOMER_TYPE_MASTER = '/v1/project-customer-type';
export const CONSUMPTION_TYPE_MASTER = '/v1/consumption-type';
export const CLOUD_PROVIDER_MASTER = '/v1/cloud-provider';
export const MASTER_PROJECT_DETAILS = '/v1/project-details';
export const MASTER_HOLIDAY_LIST = '/v1/holiday-list';
export const MASTER_RESOURCE_ALLOCATION = '/v1/resource-allocation';
export const MASTER_LEAVE_DETAILS = '/v1/leave-details';
export const MASTER_EFFORT_DATA = '/v1/effort-data';

export const IMD_ROLLUP = '/v1/imd-master-project';
export const PROJECT_STATUS_MASTER = '/v1/project-status-master';
export const IRD_USER_CUSTOMIZED_VIEW = '/v1/ird-user-customized-view';
export const MIS_EMPLOYEE_UTILIZATION_REPORT = '/v1/employee-utilization-report';
export const PROJECT_MANAGEMENT_PROJECT_STATUS = '/v1/project-status';
export const PROJECT_MANAGEMENT_PROJECT_TYPE = '/v1/project-type';
export const PROJECT_MGMT_RESOURCE_ALLOCATION = '/v1/resource-allocation';
export const PROJECT_MANAGEMENT_REDMINE_DATA = '/v1/redmine-data';
export const PROJECT_MANAGEMENT_PROJECT_DETAILS = '/v1/project-details';
export const PROJECT_MANAGEMENT_PROJECT_DETAILS_LEGACY_VERTICALS = '/v1/project-details/legacy-verticals';
export const PROJECT_MANAGEMENT_DL_GROUP_ID_VALIDATE = `${PROJECT_MANAGEMENT_PROJECT_DETAILS}/dl-group-id/validate`;
export const PROJECT_MANAGEMENT_JIRA_PROJECT_ID_VALIDATE = '/v1/project-details/jira-project-id/validate';
export const PROJECT_MANAGEMENT_VERTICAL = '/v1/vertical';
export const PROJECT_MANAGEMENT_LEAVE_DETAILS = '/v1/leave-details';
export const PROJECT_MANAGEMENT_HOLIDAY_LIST = '/v1/holiday-list';
export const PROJECT_MANAGEMENT_EMPLOYEE_MASTER = '/v1/employee-master';

export const REVENUE_RECOGNITION = '/v1/revenue-recognition';
export const ACTIVITY_REPORT = '/v1/utilization-activity-report';
export const PROJECT_UTILIZATION = '/v1/project-utilization';

export const MIS_MILESTONE = '/v1/milestone-mis';
export const MILESTONE = '/v1/milestone';
export const MILESTONE_DETAILS = '/v1/milestone-details';
export const MIS_MONTHLY_MILESTONE = '/v1/milestone-mis/monthly';
export const MILESTONE_ORPHAN_INVOICES = '/v1/milestone-mis/orphan-invoices';

export const EDR_EMPLOYEE_EFFORTS = '/v1/edr-employee-efforts';
export const EDR_EMPLOYEE_EFFORTS_SUMMARY = '/v1/edr-employee-efforts/summary';
export const EDR_ACTIVITY_REPORTS = '/v1/edr-activity-reports';
export const ALLOCATION_MIS = '/v1/allocation-mis';

export const MIS_PO = '/v1/po-mis';
export const MIS_MONTHLY_PO = '/v1/po-mis/monthly';
export const PEOPLE_VS_PROJECT_COUNT = '/v1/people-vs-project-count';
export const PEOPLE_VS_PROJECT_COUNT_FILTERS = '/v1/people-vs-project-count/filters';
export const PEOPLE_VS_PROJECT_COUNT_EXPORT = 'export';
export const PO_DETAILS_LIST = '/v1/po-details';
export const ADD_EDIT_PO_DETAILS = '/v1/po-details';
export const PO_DETAILS_CLIENTS = '/v1/po-details/clients';
export const BULK_UPDATE_PO_STATUS = '/v1/po-details/bulk/status';
export const DELETE_PO_DETAILS = '/v1/po-details';
export const EDR_PROJECT_EFFORTS = '/v1/edr-project-efforts';
export const CSAT_HISTORY = '/v1/csat-history';
export const CSAT_HISTORY_DELETE = '/v1/csat-history';
export const CSAT_HISTORY_UPDATE = '/v1/csat-history';

export const TIME_SHEET_REPORT = '/v1/time-sheet-report';
export const TIME_SHEET_REPORT_ALREADY_LOGGED_EFFORTS = '/v1/time-sheet-report/already-logged-efforts';
export const TIME_SHEET_REPORT_DELETE_EFFORT_URL = '/v1/time-sheet-report/delete-efforts';
export const TIME_SHEET_REPORT_UPDATE_EFFORT_URL = '/v1/time-sheet-report/update-efforts';
export const TIME_SHEET_REPORT_GET_EFFORT_LOGGING_DATES_URL = '/v1/time-sheet-report/effort-logging-dates';
export const TIME_SHEET_REPORT_BULK_ADD_EFFORTS_URL = '/v1/time-sheet-report/bulk-add-efforts';
export const TIME_SHEET_REPORT_GET_ACTIVITIES_OPTION_URL = '/v1/time-sheet-report/add-efforts/activities';
export const TIME_SHEET_REPORT_GET_PROJECT_NAME_OPTION_URL = '/v1/time-sheet-report/add-efforts/project_name';
export const MIS_RISK_REGISTER = '/v1/risk-register';
export const MIS_STAFFING_MIS = '/v1/staffing-mis';
export const MIS_CHANGE_REQUEST = '/v1/change-request-mis';
export const MIS_ROLE_RATIO_REPORT = '/v1/role-ratio-report';
export const PROJECT_INFO_LOOKUP = '/v1/project-info-lookup';
export const STAFFING_REQUEST = '/v1/staffing-request';
export const STAFFING_REQUEST_CREATE = '/v1/staffing-request/create';
export const STAFFING_REQUEST_META = '/v1/staffing-request/meta';
export const STAFFING_REQUEST_BULK_APPROVAL_ENDPOINT = '/v1/staffing-request/bulk/approve';
export const STAFFING_REQUEST_BULK_CLOSE_ENDPOINT = '/v1/staffing-request/bulk/close';
export const STAFFING_REQUEST_APPROVAL_ENDPOINT = '/v1/staffing-request';
export const STAFFING_REQUEST_CLOSE_ENDPOINT = '/v1/staffing-request';
export const OFFERING_WISE_REPORT = '/v1/offering-wise-report';
export const OFFERING_WISE_REPORT_FILTERS = '/v1/offering-wise-report/filters';
export const OFFERING_WISE_REPORT_EXPORT = '/v1/offering-wise-report/export';
export const TBH_RESOURCE_MANAGEMENT = '/v1/tbh-resource-management';
export const MIS_TIME_SHEET = '/v1/time-sheet-mis';
export const PROJECT_COST_REPORT = '/v1/project-cost-report';
export const PROJECT_ALLOCATION = '/v1/project-allocation';
export const PROJECT_ALLOCATION_FILTERS = '/v1/project-allocation/filters';
export const PROJECT_ALLOCATION_EXPORT = '/v1/project-allocation/export';

export const PROJECT_RIGHTS = '/v1/project-rights';
export const PROJECT_RIGHTS_FILTERS = '/v1/project-rights/filters';
export const PROJECT_RIGHTS_UPDATE_ACCESS = '/v1/project-rights/update-access';
export const PROJECT_RIGHTS_EXPORT = '/v1/project-rights/export';
export const SHIFT_ALLOWANCE = '/v1/shift-allowance';
export const SHIFT_ALLOWANCE_MIS = '/v1/shift-allowance-mis';
export const BILLING_REPORT = '/v1/billing-report';

export const SALARY_REPORT = '/v1/salary-report';
export const SALARY_REPORT_FILTER_OPTIONS = '/v1/salary-report/filters/:filterType';

export const ESTIMATED_VS_ACTUAL_REPORT = '/v1/estimation-vs-actual-mis';
export const GROSS_MARGIN_REPORT = '/v1/gross-margin-report';


export const CHANGE_REQUEST_EDIT_FORM_OPTIONS = '/v1/project-change-requests/edit-form-options';
export const CHANGE_REQUEST_DETAILS = '/v1/project-change-requests/cr-details';
export const CHANGE_REQUEST_CREATE = '/v1/project-change-requests/create';
export const CHANGE_REQUEST_APPROVE = '/v1/project-change-requests/approve-cr';

export const ALLOCATION_MAIL_STAKEHOLDERS = '/v1/allocation-mail-stakeholders';
export const ALLOCATION_MAIL_STAKEHOLDERS_VERTICALS = '/v1/allocation-mail-stakeholders/getVerticals';
export const ALLOCATION_MAIL_STAKEHOLDERS_RESOURCE_DETAILS = '/v1/allocation-mail-stakeholders/getResourceDetails';
export const ALLOCATION_MAIL_STAKEHOLDERS_EMPLOYEE_DETAILS = '/v1/allocation-mail-stakeholders/getEmployeeDetails';

export const DEPARTMENT_LIST = '/v1/department-list';
export const EMPLOYEE_EXPERIENCE = '/v1/employee-experiences';

export const EMPLOYEE_VERTICAL = '/v1/employee-vertical';
export const INVOICE_PAYMENT_STATUS = '/v1/invoice-payment-status';
export const INVOICE_STATUS = '/v1/invoice-status';

export const AI_ACCESS_REQ = '/v1/ai-access-request';
export const AI_ACCESS_DROP_DOWN_OPTIONS = '/v1/ai-access-request/dropdown-options';
export const ADD_AI_ACCESS_REQ = '/v1/ai-access-request/add-ai-access-req';
export const UPDATE_AI_ACCESS_REQ = '/v1/ai-access-request/update-ai-access-req';
export const DELETE_AI_ACCESS_REQ = '/v1/ai-access-request/delete-ai-access-req';
export const APPROVE_AI_ACCESS_REQ = '/v1/ai-access-request/approve-ai-access-req';
export const AI_ACCESS_REQ_DASHBOARD = '/v1/ai-access-request-dashboard';
export const ISSUE_CATEGORY = '/v1/issue-categories';
export const ISSUE_STATUS = '/v1/issue-status';
